<ng-container *transloco="let t; read: 'layout'">
  <button mat-icon-button [matMenuTriggerFor]="account" [disableRipple]="true">
    <mat-icon [color]="color">account_box</mat-icon>
  </button>
  <mat-menu #account>
    <div class="container">
      <div class="name">
        <span>{{ admin.getFullName() }}</span>
      </div>
      <button mat-menu-item (click)="logout()">{{ t('logout') }}</button>
    </div>
  </mat-menu>
</ng-container>
